/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {useIsPhone} from '../hooks/useMedia';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

interface MapLayerIconProps extends IconProps {
  noLayers?: boolean;
}

/*
 * Defines the Design Language System (DLS) Map Layer Icon component.
 */
export const MapLayerIcon = ({
  noLayers = false,
  ...props
}: MapLayerIconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  const isPhone               = useIsPhone();
  const color                 = noLayers && !isPhone ? dlsColor('white') : iconColor;

  return (
    <ThemeIconProvider name='MapLayerIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M20.583 8.774a.5.5 0 01-.007.747l-8.241 7.187a.5.5 0 01-.664-.006L3.417 9.226a.5.5 0 01.007-.747l8.241-7.187a.5.5 0 01.664.006l8.254 7.476z'
          stroke={color}
          strokeWidth={1.5}
          strokeMiterlimit={10} />
        <path d='M17.791 12.053l2.802 2.583a.5.5 0 01-.006.742L12.338 22.7a.5.5 0 01-.67-.006l-8.261-7.612a.5.5 0 01.006-.741L6.05 12'
          stroke={color}
          strokeWidth={1.5}
          strokeMiterlimit={10} />
        {noLayers && (
          <path d="M1 23.4697L23.6274 0.842309"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round" />
        )}
      </svg>
    )} />
  );
};
